import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Tabs, Modal } from "antd";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { renderList, setMicrositeDetails } from "../../../Reducer/globalSlice";
import { deleteRequest, getRequest, postRequest } from "../../../api/http";
import userapiservice from "../../../api/userapiservice";
import { Back, TabLeftArrow, TabRightArrow } from "../../../components/Icons/Icons";
import ShareLink from "../../../components/ShareLink/ShareLink";
import Loader from "../../../components/Loader/Loader";
import PageNotFound from "../../../components/PageNotFound/PageNotFound";
import ToastComponent from "../../../components/ToastCompoent/ToastComponent";
import usePartnerName from "../../../hooks/usePartnerName";
import PartnerCarousel from "../../partnerScreen/partnerSlider";
import ContactUsComponent from "../ContactUsComponent";
import News from "../News";
import Events from "../Events";
import ApprenticeshipsComponent from "../apprenticeshipsComponent";
import Contracts from "../contracts";
import Courses from "../courses";
import ExperienceOfWork from "../experienceOfWork";
import Products from "../products";
import Services from "../services";
import TeamsAndRoles from "../teamsAndRoles";
import Vacancies from "../vacancies";
import WhyWork from "../whyUs";
import AboutUsComponent from "./AboutUs";
import "./newMicrosite.scss";
import favorite from "../../../assets/newImages/Favorite.svg";
import favoriteActive from "../../../assets/newImages/FavoriteActive.svg";
import lockIcon from '../../../assets/images/lockIcon.png';
import { setTabValue, updateMicrositeID, setMicroSiteLogo, setMicroSiteName, setTabConfigId, setCarouselId } from "../../../Reducer/localStorageSlice";
import { enumToEnumAdaptor } from "../../../utils/util";
import { GlobalContext } from "../../../components/globalContext/GlobalContext";
import { sortCarouselData } from "../../../utils/helper";
import { role } from "../../../utils/constants";

const TAB_KEYS = {
  aboutUs: "ABOUT_US",
  product: "PRODUCTS",
  service: "SERVICES",
  contract: "CONTRACTS",
  contactUs: "CONTACT_US", 
  EXPERIENCES_OF_WORK: "EXPERIENCES_OF_WORK", // contact-us 

  apprenticeship: "APPRENTICESHIP",
  vacancy: "VACANCY",
  courses: "COURSES",

  workExperience: "WORK_EXPERIENCE",

  whyWork: "WHY_WORK_FOR_US",
  teamsAndRoles: "TEAMS_AND_ROLES",

  news: "BLOG",
  press: "IN_THE_PRESS",
  events: "EVENTS",
  // corousel: "corousel",
};

const tabsOrder = [
 
  {
    masterDataId: "3549a199-0937-11f0-b61c-6045bd0fa337", oldName: "About Us", oldTabKey: "about-us", tabKey: TAB_KEYS.aboutUs, hasSubTabs: true,
  },
  {
    masterDataId: "35499238-0937-11f0-b61c-6045bd0fa337", oldName: "Products", oldTabKey: "product", tabKey: TAB_KEYS.product, hasSubTabs: true,

  },
  {
    masterDataId: "35499789-0937-11f0-b61c-6045bd0fa337", oldName: "Services", oldTabKey: "service", tabKey: TAB_KEYS.service,
  },
  {
    masterDataId: "35499d06-0937-11f0-b61c-6045bd0fa337", oldName: "Contracts", oldTabKey: "contract", tabKey: TAB_KEYS.contract,
  },
  {
    masterDataId: "3549a0ff-0937-11f0-b61c-6045bd0fa337", oldName: "Contact Us", oldTabKey: "contact-us", tabKey: TAB_KEYS.EXPERIENCES_OF_WORK, hasSubTabs: true,
  },
  {
    masterDataId: "35499a04-0937-11f0-b61c-6045bd0fa337", oldName: "Apprenticeships", oldTabKey: "PART_TIME", tabKey: TAB_KEYS.apprenticeship,
  },
  {
    masterDataId: "35499943-0937-11f0-b61c-6045bd0fa337", oldName: "Vacancies", oldTabKey: "FULL_TIME", tabKey: TAB_KEYS.vacancy,
  },
  {
    masterDataId: "35499b63-0937-11f0-b61c-6045bd0fa337", oldName: "Courses", oldTabKey: "courses", tabKey: TAB_KEYS.courses, hasSubTabs: true,

  },
  {
    masterDataId: "35499c7c-0937-11f0-b61c-6045bd0fa337", oldName: "Why work for us", oldTabKey: "why-work", tabKey: TAB_KEYS.whyWork,
  },
  {
    masterDataId: "35499ab7-0937-11f0-b61c-6045bd0fa337", oldName: "Our teams and roles", oldTabKey: "teams-and-roles", tabKey: TAB_KEYS.teamsAndRoles, hasSubTabs: true,

  },
  {
    masterDataId: "35499bf8-0937-11f0-b61c-6045bd0fa337", oldName: "Experiences of work", oldTabKey: "work-experience", tabKey: TAB_KEYS.workExperience,
  },
  {
    masterDataId: "35499d91-0937-11f0-b61c-6045bd0fa337", oldName: "Blog", oldTabKey: "news_tab", tabKey: TAB_KEYS.news,
  },
  {
    masterDataId: "35499e19-0937-11f0-b61c-6045bd0fa337", oldName: "In The Press", oldTabKey: "press", tabKey: TAB_KEYS.press,
  },
  {
    masterDataId: "f85bed2b-a117-11f1-a5d8-000d3ad641ca", oldName: "Events", oldTabKey: "events", tabKey: TAB_KEYS.events,
  },
];
const position = ["left", "right"]

const NewMicrosite = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { globalState } = useContext(GlobalContext);
  const isShared = useSelector(state => state.global.isShared)
  const reduxGlobalState = useSelector(state => state.global)
  const localData = useSelector((state) => state?.localStorage)
  const { partnerId, tabValue, micrositeID, accessToken: localDataAccessToken, partner:subDomainName } = localData
  const queryParams = new URLSearchParams(location?.search);
  const fromList = queryParams.get("fromList");
  let tabInterestName = enumToEnumAdaptor(queryParams.get('interestName'))
  // default → TRUE for end user
  const showDetails = fromList !== "false";
  const mobileNumber = reduxGlobalState?.userProfile?.phoneNumber;


  const [loading, setLoading] = useState(true);
  const [microSiteId, setMicroSiteId] = useState(null);
  const [filteredTabs, setFilteredTabs] = useState([]);
  const [filteredTabsObject, setFilteredTabsObject] = useState({});
  const [carouselData, setCarouselData] = useState([]);

  const [missingTabsAboutUs,setMissingTabsAboutUs] = useState([])
  const [missingTabsContactUs,setMissingTabsContactUs] = useState([])
  const [missingMainTabs,setMissingMainTabs] = useState(null)
  const [activeKey, setActiveKey] = useState(tabInterestName || TAB_KEYS.aboutUs);
  const [siteSetting, setSiteSitting] = useState(null);
  const [allBookmarkedSites, setAllBookmarkedSites] = useState([])
  const [, setBookmarked] = useState(false);
  const [micrositeNotFound, setMicrositeNotFound] = useState(false);

  const [favMicroSites, setFavMicroSites] = useState(false);
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (filteredTabsObject[activeKey]) {
      dispatch(setTabConfigId(filteredTabsObject[activeKey].id))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, filteredTabsObject])

  const aboutUsMissingTabData = async (id) => {
    const res = await getRequest(
      userapiservice.getAboutUsMissingDataTabs(id),
      {},
      false
    )
    setMissingTabsAboutUs(res)
  }

  const mainMissingTabsData = async (id) => {
    const res = await getRequest(
      userapiservice.getMissingMainTabs(id),{},false
    )

    console.log('mainMissingTabs',res)
    setMissingMainTabs(res)
    console.log('missingMainTabs',missingMainTabs)
  }

  const contactUsMissingTabData = async (id) => {
    const res = await getRequest(
      userapiservice.getContactUsMissingDataTabs(id),
      {},
      false
    )
    setMissingTabsContactUs(res)
  }

  useEffect(()=>{

    if(microSiteId) {
      try{

        aboutUsMissingTabData(microSiteId)
        contactUsMissingTabData(microSiteId)
        mainMissingTabsData(microSiteId)

      }catch(err){
        toast.error(err?.response?.data?.message)
      }
      
    }
  },[microSiteId])

  // using useEffect to set values from local storage
  const { formattedName: partner } = usePartnerName()
  const [phoneNumber, setPhoneNumber] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const [allTabsList, setAllTabsList] = useState([])

  useEffect(() => {
    if (localDataAccessToken) {
      setAccessToken(localDataAccessToken);
    }
    if (micrositeID) {
      setMicroSiteId(micrositeID)
    }
    if (localStorage.getItem("Phone Number")) {
      setPhoneNumber(localStorage.getItem("Phone Number"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handling changing tabs
  const changeTab = (tabValue) => {
    dispatch(setTabValue(tabValue))
    setTabConfigId()
    setActiveKey(tabValue);
    dispatch(setTabConfigId(filteredTabsObject[tabValue]?.id))
  };

  const tabValueNormaliser = {
    product:'PRODUCTS',
    service:'SERVICES',
    contract: 'CONTRACTS',
    vacancy: 'VACANCY',
    apprenticeship: 'APPRENTICESHIP',
    'work-experience':'WORK_EXPERIENCE',
    courses: 'COURSES'
  }
  const masterDataToComponentMapping = useCallback((masterDataId, props) => {
    switch (masterDataId) {
      case "35499ab7-0937-11f0-b61c-6045bd0fa337": return <TeamsAndRoles  {...props} />;
      // case "35499f49-0937-11f0-b61c-6045bd0fa337": return <BusinessCard {...props} />;
      case "35499e19-0937-11f0-b61c-6045bd0fa337": return <News {...props} activeKey={'press'} />;
      case "f85bed2b-a117-11f1-a5d8-000d3ad641ca": return <Events {...props} />;
      // case "3549a077-0937-11f0-b61c-6045bd0fa337": return <Carousel {...props} />;
      case "35499bf8-0937-11f0-b61c-6045bd0fa337": return <ExperienceOfWork  {...props} />;

      case "35499d91-0937-11f0-b61c-6045bd0fa337": return <News {...props} />;
      case "35499b63-0937-11f0-b61c-6045bd0fa337": return <Courses  {...props} />;
      case "35499943-0937-11f0-b61c-6045bd0fa337": return <Vacancies  {...props} />;
      case "35499d06-0937-11f0-b61c-6045bd0fa337": return <Contracts  {...props} />;
      case "3549a0ff-0937-11f0-b61c-6045bd0fa337": return <ContactUsComponent  {...props} missingTabs={missingTabsContactUs} />;
      case "3549a199-0937-11f0-b61c-6045bd0fa337": return <AboutUsComponent  {...props} missingTabs={missingTabsAboutUs} />;
      case "35499a04-0937-11f0-b61c-6045bd0fa337": return <ApprenticeshipsComponent  {...props} />;
      case "35499238-0937-11f0-b61c-6045bd0fa337": return <Products  {...props} />;
      case "35499c7c-0937-11f0-b61c-6045bd0fa337": return <WhyWork  {...props} />;
      case "35499789-0937-11f0-b61c-6045bd0fa337": return <Services  {...props} />;
      default: return <></>;
    }
  },[missingTabsAboutUs, missingTabsContactUs])

  const fetchAllProSettings = async () => {
    try {
      // setLoading(true);
      const res = await getRequest(
        userapiservice.getAllProSettings(micrositeID),{},false
      );
      const appCarouselId = res?.find((item) => item?.masterDataId === '3549a077-0937-11f0-b61c-6045bd0fa337')
      getTabData(micrositeID, appCarouselId?.id)

      const proSettingsObject = {};
      res.forEach((setting) => {
        proSettingsObject[setting.masterDataId] = setting;
      });

      const tempFilteredTabsObject = {};

      const newTabsList = tabsOrder
      ?.filter((t)=> {
        if(missingMainTabs?.length){
          return !missingMainTabs?.some((m)=>m===t?.tabKey)
        }
        return true
      })
        .map((tab) => {
          const setting = proSettingsObject[tab.masterDataId];

          if (!setting) {
            console.warn(
              `Missing proSetting for masterDataId: ${tab.masterDataId}`
            );
            return null;
          }

          const tabComponent = masterDataToComponentMapping(
            tab.masterDataId,
            { changeTab }
          );

          const tabConfig = {
            ...tab,
            ...setting,
            component: tabComponent,
            default: setting.tabType === "MANDATORY_TABS",
            tabName: setting.displayName,
          };

          const isVisible =
            setting.tabType === "MANDATORY_TABS" ||
            (setting.primaryToggle && setting.secondaryToggle);

          if (isVisible) {
            tempFilteredTabsObject[tab.tabKey] = tabConfig;
          }

          return tabConfig;
        })
        .filter(Boolean);

      dispatch(
       
        setTabConfigId(
          tempFilteredTabsObject?.[activeKey]?.id

        )
      );
      dispatch(
        setCarouselId(
          proSettingsObject?.["3549a077-0937-11f0-b61c-6045bd0fa337"]?.id ||
          ""
        )
      );
      setAllTabsList(newTabsList);
      setFilteredTabs(newTabsList);

      setFilteredTabsObject(tempFilteredTabsObject);
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={
            error?.response?.data?.message || "Sorry, Something went wrong"
          }
        />
      );
    } finally{
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  console.log('fill',filteredTabs)
  console.log('allTabsList',allTabsList)

  useEffect(() => {

    if (micrositeID && missingMainTabs) {
      fetchAllProSettings()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [micrositeID, missingTabsAboutUs, missingTabsContactUs, missingMainTabs])


  const slot = useMemo(() => {
    if (position.length === 0) return null;

    const onClickArrow = (direction, filteredTabs) => {

      const getIndex = filteredTabs.findIndex((d) => d.tabKey === activeKey);
      if (getIndex !== -1) {
        if (direction === "right" && filteredTabs[getIndex + 1].tabKey) {
          changeTab(filteredTabs[getIndex + 1].tabKey)
        } else if (
          direction === "left" &&
          filteredTabs[getIndex - 1].tabKey
        ) {
          changeTab(filteredTabs[getIndex - 1].tabKey)
        }
      }
    };

    const OperationsSlot = {
      left: (
        <div className="cursor-pointer" onClick={() => { onClickArrow("left", filteredTabs) }}>
          <TabLeftArrow customClassName='arrow' />
        </div>
      ),
      right: (
        <div className="cursor-pointer" onClick={() => onClickArrow("right", filteredTabs)}>
          <TabRightArrow customClassName='arrow' />
        </div>
      ),
    };

    return position.reduce(
      (acc, direction) => ({
        ...acc,
        [direction]: OperationsSlot[direction],
      }),
      {}
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, activeKey, filteredTabs]);

  const getBookMark = async () => {
    try {
      if(mobileNumber) {
   const response = await getRequest(
        userapiservice.getBookmark(mobileNumber, subDomainName,role)
      );
      if(response?.microsites?.length)  {
        const filteredName  = response?.microsites?.find((microsite) => microsite?.name === reduxGlobalState?.micrositeDetails?.micrositeName)?.name
        if(filteredName) {
          setFavMicroSites(true)
        }
      }
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)

    }

  }

  useEffect(() => {
    getBookMark()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const postBookmark = async (id, name) => {
    try {
      const response = await postRequest(
        userapiservice.postBookmark(id, mobileNumber,role)
      );
      if (response) {
        toast.success(<ToastComponent type={'Success'} message={`${name} added to favorites`} />)
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const removeBookmark = async () => {
    try {
      const response = await deleteRequest(
        userapiservice.removeBookmark(microSiteId, mobileNumber,role)
      );

      if (response) {
        toast.success(<ToastComponent type={'Success'} message={'Removed from favorites'} />)

      }
    } catch (error) {
      error?.response?.data?.message &&
        toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)

    }
  };

  const handleBookmark = () => {
    if (favMicroSites) {
      if (accessToken) {
        setBookmarked(true);
        removeBookmark();

      }
      else {
        toast.error(<ToastComponent type={'Error'} message={'Please login to favorite site'} />)

      }
    } else {
      postBookmark(microSiteId, reduxGlobalState?.micrositeDetails?.micrositeName);
      setBookmarked(false);
    }
  };

  useEffect(() => {
    let tabVal = tabValueNormaliser[tabValue] || tabValue;
    if(tabInterestName && missingMainTabs?.length && !missingMainTabs?.includes(tabInterestName)){
      setActiveKey(tabInterestName)
    }
    else {
      if(!tabValue || missingMainTabs?.includes(tabVal) ){
        tabVal = TAB_KEYS.aboutUs
      }
      const previousActiveTabExists = filteredTabs.some(tab => tab.tabKey === tabVal)
      if (filteredTabs && tabVal && previousActiveTabExists) {
        setActiveKey(tabVal);
      }
    }

    // Get microsite ID using the microsite name from URL path
    const getMicrositeDetails = async () => {
      try {
        // setLoading(true)
        const micrositeName = location.pathname.split("/")[2];
        const response = await getRequest(
          userapiservice.getMicrositeDetailsByName(micrositeName.replace(/_/g, " "))
        );
        if (response) {
          setMicroSiteId(response[0].id);
          dispatch(updateMicrositeID(response[0]?.id))
        }
      } catch (error) {
        error?.response?.data?.message &&
          toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)

        if (error.response.status === 400) {
          setMicrositeNotFound(true)
        }
        setLoading(false)
      }
      // finally {
      //   setLoading(false)
      // }
    };

    getMicrositeDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredTabs, location.pathname, missingMainTabs, tabValue]);

  useEffect(() => {
    if (microSiteId) {
      allBookmarkedSites.forEach((id) => {
        if (id === microSiteId) {
          setBookmarked(true);
        }
      });
    }
  }, [allBookmarkedSites, microSiteId]);


  useEffect(() => {
    // Get favorites 
    const getBookmark = async () => {
      try {
        const response = await getRequest(
          userapiservice.getBookmark(phoneNumber, partner)
        );
        if (response) {
          setAllBookmarkedSites(response?.microsites
            .map((microsite) => microsite?.id))
        }
      } catch (error) {
        error?.response?.data?.message && toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)

      }
    };
    if (phoneNumber && partner) {
      getBookmark();
    }
  }, [phoneNumber, partner])

  useEffect(() => {
    // Get pro settings
    const getSiteSetting = async () => {
      try {
        // setLoading(true);
        if (microSiteId) {
          const { settings: response } = await getRequest(
            userapiservice.getsettings(microSiteId, partnerId),
            {},
            false
          );
          if (response) {
            if (localData?.age > 18) {
              setSiteSitting(response);
            } else {
              let tempObj = {
                ...response,
                // vacancies: true,
                // contract: true,
              };
              setSiteSitting(tempObj);
            }
          }
        }
      } catch (error) {
        error?.response?.data?.message &&
          toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)
        setLoading(false);
      } 
      // finally {
      //   setLoading(false);
      // }
    };

    // Get header logo
    const getMicrositeLogo = async () => {

      try {
        // setLoading(true)
        const response = await getRequest(userapiservice.getMicrositeLogo(microSiteId));
        dispatch(setMicrositeDetails({ micrositeLogo: response?.mediaLink, micrositeName: response?.name }))
      } catch (error) {
        error?.response?.data?.message &&
          toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)
        setLoading(false);
      }
      // finally {
      //   setLoading(false)
      // }
    };

    if (microSiteId) {
      getSiteSetting();
      getMicrositeLogo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [microSiteId]);


  const getTabData = async (micrositeId, id) => {
    try {
      // setLoading(true);
      const response = await getRequest(
        userapiservice.getMicrositeDetailsTabs(micrositeId, id)
      );
      if (response) {
        const result = sortCarouselData(response);
        const sortedData = [...result];
        const [item] = sortedData?.splice(0, 1); // Remove from index 0
        sortedData?.splice(1, 0, item);  
        setCarouselData(sortedData);

      }
    } catch (error) {
      error?.response?.data?.message &&
      toast.error(<ToastComponent type={'Error'} message={error?.response?.data?.message || 'Sorry, Something went wrong'} />)
    } finally{
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (siteSetting) {
      let localFilteredTabs = allTabsList.filter((tab) => {
        return tab.default || siteSetting[tab.settingsKey];
      });
      setFilteredTabs(localFilteredTabs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteSetting]);

  // set microsite logo url in localstorage to use in microsite details page after reload
  useEffect(() => {
    dispatch(setMicroSiteLogo(reduxGlobalState?.micrositeDetails?.micrositeLogo))
    dispatch(setMicroSiteName(reduxGlobalState?.micrositeDetails?.micrositeName))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxGlobalState.micrositeDetails])

  return (
    <div className={`microsite-container ${isShared ? 'h-100' : ''} `}>
        <motion.div
          className="microsite-background-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {!loading && filteredTabs?.length > 0 ? (<div className='microsite-body-container'>
            <div className="microsite-title-bar-container" >
              <div>
                {
                  location?.state && Object.keys(location.state).length > 0 && (
                    <span
                      className='microsite-back-btn'
                      onClick={() => {
                        navigate('/microsite')
                        dispatch(renderList(true))
                      }}
                    >
                      <Back />
                    </span>
                  )
                }
              </div>

              <div className='microsite-navbar'>
                <span className="microsite-brand">
                  {reduxGlobalState?.micrositeDetails?.micrositeLogo &&
                    < img src={reduxGlobalState?.micrositeDetails?.micrositeLogo} className="img-fluid" alt="" />}
                </span >
                <strong className="microsite-brand-title" >
                  {reduxGlobalState?.micrositeDetails?.micrositeName}
                </strong>
              </div>


              {showDetails &&
                <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                  {!globalState.isMobile && <ShareLink shareUrl={window.location.href} />}
                  
                  <div
                    style={{ cursor: "pointer", marginTop: "-5px" }}
                    onClick={() => {
                      if (accessToken) {
                        setFavMicroSites(!favMicroSites);
                        handleBookmark()
                      } else {
                        setShowModal(true)
                      }
                    }}
                  >
                    <img
                      alt="fav-icon"
                      src={favMicroSites ? favoriteActive : favorite}
                      className="fav-icon"
                    />
                  </div>
                </div>
              }


            </div>

            <div className="carousel-container   bg-white">
              {carouselData && <PartnerCarousel carouselData={carouselData} />}
            </div>

            {<div className="tabs-container">
              {filteredTabs && (
                <Tabs
                  onChange={changeTab}
                  activeKey={activeKey}
                  defaultActiveKey={tabInterestName || TAB_KEYS.aboutUs}
                  tabBarExtraContent={slot}
                  className="microsite-tabs"
                  popupClassName="tabs-dropdown"
                  type="card"
                  tabBarGutter={3}
                  destroyInactiveTabPane // will cause dropdown to glitch
                  items={filteredTabs.map((tab) => {
                    return {
                      label: tab?.displayName || tab?.tabName || '',
                      key: tab?.tabKey || '',
                      children:
                        <div className={`tab-content-wrapper ${tab?.hasSubTabs ? 'h-100' : ''}`}>
                          {tab?.component ? tab?.component
                            :
                            <div className='tab-body-container' >
                              {tab?.tabName}
                            </div>}
                        </div>
                      ,
                    };
                  })}
                />
              )}
            </div>}
          </div>) : (
            <div className='microsite-body-container w-100 d-flex justify-content-center '>
              {!micrositeNotFound ? <Loader /> : <PageNotFound
                message={`${isShared ? "Oops...!  The site you're looking for does not exist please contact administrator"
                  :
                  "Oops...!  The site you're looking for does not exist"}`}
                showLinks={isShared ? false : true}
                links={[
                  { message: 'View list of', title: 'Sites', link: "/microsite" }
                ]} />}
            </div>
          )}
        </motion.div>

      {showModal &&
        <Modal
          open={showModal}
          onCancel={() => setShowModal(false)}
          footer={false}

        >
          <div>
            <div
              className="info-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: "1",
                justifyContent: "center",
              }}
            >
              <img src={lockIcon} alt="Partner Logo" />
              <span className="text-to-contact-info">
                Please login to access Favorites
              </span>
              <a
                href="/login"
                style={{ color: "#3067AE" }}
                className="text-to-contact-info"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/login", { state: { page: "microsite" } });
                }}
              >
                Login

              </a>
            </div>
          </div>
        </Modal>
      }
    </div>
  )
}

export default NewMicrosite;
